import { ResponseDto } from '../../shared/dtos/response.dto';

export interface AccessRightDto {
    accessRightId: number;
    accessRightName: string;
    accessRightDescription: string;
}

export interface RoleDto {
    roleId: number;
    name: string;
    description: string;
    accessRights: AccessRightDto[];
}

export interface MemberDto {
    memberId: number;
    type: string;
    status: number;
    roles: RoleDto[];
}

export interface MemberResponseDto extends ResponseDto {
    member: MemberDto;
}

/* eslint-disable no-unused-vars */
export enum AccessRightEnum {
    ADMIN = 'ADMIN_FUNCTIONS',
    COMMON = 'SUPPORT_FUNCTIONS'
}
